/**
 * X Close Icon Component
 *
 * Close/dismiss icon for mobile navigation and modals.
 * Figma: X Icon (Node: 895:24090)
 *
 * Sizes:
 * - Default: 10.492px
 * - Large: 14px
 * - XL: 18px
 */
"use client";

import Image from "next/image";

interface XIconProps {
  size?: "default" | "large" | "xl";
  className?: string;
  onClick?: () => void;
}

export function XIcon({ size = "large", className = "", onClick }: XIconProps) {
  const sizeMap = {
    default: 10.492,
    large: 14,
    xl: 18,
  };

  const iconSize = sizeMap[size];

  return (
    <button
      onClick={onClick}
      className={`relative flex items-center justify-center transition-opacity hover:opacity-70 ${className}`}
      style={{
        width: `${iconSize}px`,
        height: `${iconSize}px`,
      }}
      aria-label="Close menu"
    >
      <Image src="/icons/x-icon.svg" alt="" width={iconSize} height={iconSize} />
    </button>
  );
}
